<script setup>
import { Link, usePage } from "@inertiajs/vue3";
import LongArrow from "@/Components/svg/LongArrow.vue";
import NewsLetterForm from "@/Components/NewsLetterForm.vue";
import LinkedInIcon from "@/Components/svg/LinkedInIcon.vue";
import PageLink from "@/Components/PageLink.vue";

const {
  props: {
    siteSettings: { linkedIn, quick_links, footer_menu },
  },
} = usePage();

const quick_links_grouped = quick_links.reduce((resultArray, item, index) => {
  const chunkIndex = Math.floor(index / 2);
  if (!resultArray[chunkIndex]) {
    resultArray[chunkIndex] = [];
  }
  resultArray[chunkIndex].push(item);
  return resultArray;
}, []);

const currentYear = new Date().getFullYear();
</script>

<template>
  <footer class="print:hidden w-full flex flex-wrap items-center z-30">
    <div
      class="w-full border-b border-b-brand-dark-blue md:border-b-0 md:w-1/2 lg:w-1/3 flex flex-wrap sm:border-r border-r-brand-dark-blue"
    >
      <div class="w-4/12 sm:w-4/12 md:w-1/3 pl-3 lg:pl-6 pt-5">
        <h5 class="uppercase">Quick<br />Links</h5>
      </div>
      <div class="w-8/12 md:w-2/3 overflow-hidden">
        <div
          class="aspect-square border-l border-l-brand-dark-blue flex flex-wrap"
        >
          <div
            v-for="(group, index) in quick_links_grouped"
            :key="index"
            class="w-full h-1/2 first:border-b border-b-brand-dark-blue flex flex-wrap"
          >
            <div
              v-for="(item, key) in group"
              :key="key"
              class="flex w-1/2 h-full last:border-l border-l-brand-dark-blue relative overflow-hidden"
            >
              <Link
                :href="item.link.href"
                target="_self"
                class="p-3 !cursor-pointer pt-6 lg:pl-4 lg:pt-5 h-full w-full flex flex-wrap whitespace-normal justify-start"
              >
                <div class="w-full">{{ item.link.title }}</div>
                <div class="mt-auto w-full">
                  <LongArrow class="fill-brand-dark-blue max-w-[110px]" />
                </div>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="w-full h-full sm:w-full md:w-1/2 lg:w-2/3 px-4 sm:px-6 py-6 sm:py-0"
    >
      <NewsLetterForm />
    </div>
    <div
      class="w-full flex flex-wrap font-sans text-[10px] uppercase border-t border-t-brand-dark-blue"
    >
      <div
        class="w-full flex flex-wrap justify-between lg:w-1/3 px-3 lg:px-6 py-6 lg:py-8 lg:border-r lg:border-r-brand-dark-blue"
      >
        <span>© {{ currentYear }} ACSEV All Rights Reserved.</span>
        <span
          >Site by
          <a
            href="https://studiofame.com.au/"
            class="hover:underline font-bold"
            target="_blank"
            >Studio Fame</a
          ></span
        >
      </div>
      <div
        id="footer-menu-container"
        class="[&_ul]:!m-0 w-full flex-wrap justify-between h-full hidden sm:flex lg:flex sm:w-7/12 md:w-1/2 lg:w-2/3 px-4 sm:px-6 py-6 lg:py-8 sm:py-0"
      >
        <a
          v-if="linkedIn && linkedIn.length"
          :href="linkedIn"
          target="_blank"
          class="p-0 social-link"
        >
          <LinkedInIcon />
        </a>
        <ul
          class="group !px-3 !m-0 lg:!pl-0 !list-none flex text-right sm:!mt-4 md:space-x-4 lg:space-x-8 xl:space-x-12"
        >
          <li v-for="(item, index) in footer_menu" :key="index" class="!my-0">
            <PageLink
              :link="item.link"
              :show-arrow="false"
              class="!p-0 h-auto font-bold !leading-none uppercase font-sans text-[10px]"
            >
              {{ item.link.title }}
            </PageLink>
          </li>
        </ul>
      </div>
    </div>
  </footer>
</template>

<style scoped>
@media (max-width: 768px) {
  .aspect-square {
    aspect-ratio: 1;
  }
}
</style>
